import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { PlatformHttpService } from '../../common/http/service/platformhttp.service';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Constants } from '../../common/constants';
import { Observable, Subject, BehaviorSubject, Subscriber, of } from 'rxjs';
import { ProductQuantity } from '../../models/product-quantity';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ProductBasicResponse, Product } from '@pdp/common';
import { FeaturedProductsResponse } from '../../models/featured-product-basic-response';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ProductService implements OnDestroy {

  // Constructor
  constructor(public platformHttpService: PlatformHttpService,
    public http: HttpClient,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: string) {
    this.compareProducts.subscribe(products => products = products);

    this._refreshSubjectProduct
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(this.getProduct.bind(this));
  }

  private _refreshSubjectProduct: Subject<string> = new Subject<string>();

  // Single product
  private _product: Subject<Product> = new Subject<Product>();
  public product: Observable<Product> = this._product.asObservable();
  private unsubscribe: Subject<void> = new Subject();


  public compareProducts: BehaviorSubject<ProductBasicResponse[]> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;

  // Handles single product when clicked
  public updateProduct(productId): void {
    this._refreshSubjectProduct.next(productId);
  }

  public findFeaturedForCategoryName(categoryName: string): Observable<FeaturedProductsResponse> {
    return this.platformHttpService.get(Constants.PRODUCT + '/featured/' + categoryName);
  }

  public findFrequentlyPurchasedTogether(productId): Observable<ProductBasicResponse[]> {
    return <Observable<ProductBasicResponse[]>>this.platformHttpService.get(Constants.PRODUCT + '/frequently-purchased-together/' + productId);
  }

  /**
   * Get single product by id
   */
  public getProduct(productId: number): void {
    const params = new HttpParams().set('id', productId);
    this.platformHttpService.get(Constants.PRODUCT, params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((product: Product) => {
        // The backend answers 200 with an EMPTY body for a nonexistent id, so
        // the error callback below never fires — the product page rendered
        // blank with a 200 status (a soft 404 for every deleted product).
        if (!product) {
          setTimeout(() => {
            this.router.navigate(['page-not-found'], { replaceUrl: true });
          });
          return;
        }
        this._product.next(product);
      }, error => {
        // https://stackoverflow.com/questions/38891002/angular-2-replace-history-instead-of-pushing
        // da bi user mogao da klikne na back button i da ga ne odvede na product koji je 404 pa da redirectovan na page not fount all over again
        setTimeout(() => {
          this.router.navigate(['page-not-found'], { replaceUrl: true });
        });
      });
  }


  public findOne(productId: number): Observable<Product> {
    return this.platformHttpService.get(Constants.PRODUCT, new HttpParams().set('id', productId + ''));
  }

  public computeQuantity(quantityAvailable: any, salesAvailabilityType: string): ProductQuantity {
    let availability: string;
    let quantityLow: boolean = false;
    if (quantityAvailable) {
      if (!isNaN(quantityAvailable) && salesAvailabilityType === 'CHECK_QUANTITY') {
        // this.availability = (availabilityForEvaluation <=5) ? availabilityForEvaluation : "Na stanju";
        if(quantityAvailable <= 10) {
          availability = $localize`:@@ManjeOd10Komada:Količina na stanju je manje od 10 komada`;
          quantityLow = true;
        }  else {
          availability = $localize`:@@NaStanju:Na stanju`;
        }
      } else {
        availability = $localize`:@@NaStanju:Na stanju`;
      }
    } else {
      availability = $localize`:@@NijeNaStanju:Nije na stanju`;
    }
    return new ProductQuantity(availability, quantityLow);
  }


  public products = []; //localStorage ? JSON.parse(localStorage.getItem('compareItem')) || [] : [];
  /*
     ---------------------------------------------
     ----------  Compare Product  ----------------
     ---------------------------------------------
  */

  // Get Compare Products
  public getComapreProducts(): Observable<ProductBasicResponse[]> {
    const itemsStream = new Observable(observer => {
      observer.next(this.products);
      observer.complete();
    });
    return <Observable<ProductBasicResponse[]>>itemsStream;
  }

  // If item is aleready added In compare
  public hasProduct(product: ProductBasicResponse): boolean {
    const item = this.products.find(item => item.id === product.id);
    return item !== undefined;
  }

  // Add to compare
  public addToCompare(product: ProductBasicResponse): ProductBasicResponse | boolean {
    let item: ProductBasicResponse | boolean = false;
    if (this.hasProduct(product)) {
      item =this.products.filter(item => item.id === product.id)[0];
      const index = this.products.indexOf(item);
    } else {
      if (this.products.length < 4) {
        this.products.push(product);
      }
      else {
      } // toasr services
    
    }
    if (isPlatformBrowser(this.platformId)) {
      // localStorage.setItem('compareItem', JSON.stringify(this.products));
    }
    return item;
  }

  // Removed Product
  public removeFromCompare(product: ProductBasicResponse) {
    if (product === undefined) { return; }
    const index = this.products.indexOf(product);
    this.products.splice(index, 1);
    if (isPlatformBrowser(this.platformId)) {
      // localStorage.setItem('compareItem', JSON.stringify(this.products));
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
